import React, { useState } from "react";
import ContractAuditModal from "../../../modals/ContractAuditModal";
import { useTranslation } from '../../../../contexts/TranslationProvider';
import '../buttons.scss'

function AuditButton() {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);

  return <>
    <button className="navbar-button" onClick={() => setShowModal(true)}>
      {t("navbar.audit")}
    </button>
    {showModal && <ContractAuditModal onClose={() => setShowModal(false)} />}
  </>
}

export default AuditButton;
